import React, { useContext, useEffect, useState } from "react";
import Avatar from "@mui/joy/Avatar";
import ExpandIcon from "@mui/icons-material/Expand";
import Ticket from "./CrmTicket";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Carousel from "./CrmCarousal";
import CrmDrawer from "./CrmDrawer";
import "./Crm.css";
import AddIcon from "@mui/icons-material/Add";
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import Breadcrumb from "./CrmBreadcrumb";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CRMRelaySkeleton from "./Components/CrmRelayskelton";
import CrmNewDrawer from "./CrmNewDrawer";
import CrmNewRelayDrawer from "./CrmNewRelayDrawer";
import Reminder from "./CrmReminders";
import BookmarksIcon from "@mui/icons-material/Bookmarks";
import { CrmMainService } from "../../../service/manage/crm/crm_main.service";
import { sweetStatusAlert } from "../../../components/common/SweetAlert";
import { Switch, FormControlLabel, CircularProgress } from "@mui/material";
import HeightIcon from "@mui/icons-material/Height";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import BookmarksContext, { BookmarksProvider } from "./context/BookmarkContext";
import BarChartIcon from "@mui/icons-material/BarChart";
import CrmStatModel from "./CrmStatModel";
import { use } from "react";

const TicketContainer = ({
  onClick,
  blockId,
  blockTitle,
  block_status,
  block_match,
  task_status,
  onDelete,
}) => (
  <div className="ticketWrapper">
    <div onClick={onClick}>
      <Ticket
        blockId={blockId}
        blockTitle={blockTitle}
        block_status={block_status}
        block_match={block_match}
        task_status={task_status}
        onDelete={onDelete}
      />
    </div>
  </div>
);
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1400,
};

const CRMRelay = ({
  searchFilters,
  searchLoading,
  state,
  handleSearchFilter,
  searchResetTrigger,
  handleFilterForLinkedBlocks,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [newDrawerOpen, setNewDrawerOpen] = useState(false);
  const [selectedSearchFilter, setSelectedSearchFilter] = useState(null);
  const [relayDrawerOpen, setRelayDrawerOpen] = useState(false);
  const [prevTicket, setPrevTicket] = useState(null);
  const [nextTicket, setNextTicket] = useState(null);
  const [row, setRow] = useState([]);
  const maxTickets =
    searchFilters?.length > 0
      ? Math.max(...searchFilters.map((row) => row.length))
      : 0;

  const [sortOrder, setSortOrder] = useState(Array(maxTickets).fill(null));
  const [formattedSortOrder, setFormattedSortOrder] = useState("");
  const [matchSwitch, setMatchSwitch] = useState(0);
  const [isModalNotificationModel, setIsModalNotificationModel] =
    useState(false);

  const [selectedSortOrder, setSelectedSortOrder] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isChartModalOpen, setIsChartModalOpen] = useState(false);
  const [bookmarkLoading, setBookmarkLoading] = useState(false);
  const [reminders, setReminders] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);

  const { bookmarks, updateBookmark } = useContext(BookmarksContext);

  useEffect(() => {
    fetchAllReminders();
  }, []);

  useEffect(() => {
    if (reminders.length > 0) {
      const count = reminders.filter(
        (reminder) => reminder.remninder_status === "1"
      ).length;
      setNotificationCount(count);
    } else {
      setNotificationCount(0);
    }
  }, [reminders]);

  const fetchAllReminders = async () => {
    try {
      const response = await CrmMainService.getAllReminders(
        state?.state.mid,
        state?.state.lg_user_id,
        state?.state.lg_user_table_id
      );
      setReminders(response?.data || []);
    } catch (error) {
      console.error("Error fetching reminders", error);
      setReminders([]);
    }
  };

  useEffect(() => {
    setSortOrder(Array(maxTickets).fill(null));
    setFormattedSortOrder("");
    setMatchSwitch(0);
    setSelectedSortOrder([]);
  }, [searchResetTrigger]);

  const handleToggle = (index, order) => {
    const newSortOrder = [...sortOrder];
    newSortOrder[index] = order;

    let newSelectedSortOrder = [...selectedSortOrder];

    if (order === null) {
      newSelectedSortOrder = newSelectedSortOrder.filter((i) => i !== index);
    } else {
      newSelectedSortOrder = newSelectedSortOrder.filter((i) => i !== index);

      newSelectedSortOrder.push(index);
    }

    setSortOrder(newSortOrder);
    setSelectedSortOrder(newSelectedSortOrder);
    updateFormattedSortOrder(newSortOrder, newSelectedSortOrder);
  };

  const handleClearAll = () => {
    setSortOrder(Array(maxTickets).fill(null));
    setSelectedSortOrder([]);
    setFormattedSortOrder("");

    handleSearchFilter("");
  };

  const updateFormattedSortOrder = (sortOrderArray, selectedOrder) => {
    // Use the selectedOrder array to maintain the sequence of selections
    const formattedArray = selectedOrder
      .map((index) => {
        const order = sortOrderArray[index];
        return order !== null && order !== undefined
          ? `${index + 1}${order}`
          : null;
      })
      .filter((order) => order !== null && order !== undefined)
      .join("|");

    setFormattedSortOrder(formattedArray);
    handleSearchFilter(formattedArray);
  };

  const handleOpenModal = (rowIndex) => {
    setExpandedRowIndex(rowIndex);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setExpandedRowIndex(null);
  };

  const handleOpenDrawer = (selectedTicket, row) => {
    const ticketIndex = row.findIndex((ticket) => ticket === selectedTicket);

    const prevTicket = ticketIndex > 0 ? row[ticketIndex - 1] : null;
    const nextTicket =
      ticketIndex < row.length - 1 ? row[ticketIndex + 1] : null;

    setSelectedSearchFilter(selectedTicket);
    setPrevTicket(prevTicket);
    setNextTicket(nextTicket);
    setRow(row);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => setDrawerOpen(false);

  const handleNavigate = (ticket) => {
    const ticketIndex = row.findIndex((t) => t === ticket);

    const prevTicket = ticketIndex > 0 ? row[ticketIndex - 1] : null;
    const nextTicket =
      ticketIndex < row.length - 1 ? row[ticketIndex + 1] : null;

    setSelectedSearchFilter(ticket);
    setPrevTicket(prevTicket);
    setNextTicket(nextTicket);
  };

  const handleOpenNewDrawer = (prevTicket = null, nextTicket = null) => {
    setSelectedSearchFilter({ prevTicket, nextTicket });
    setNewDrawerOpen(true);
  };

  const handleOpenRelayDrawer = () => setRelayDrawerOpen(true);
  const handleCloseRelayDrawer = () => setRelayDrawerOpen(false);

  const handleCloseNewDrawer = () => setNewDrawerOpen(false);

  const handleOpenDrawerBookmark = async (block) => {
    try {
      setBookmarkLoading(true);

      const { f14, f11 } = block;

      const updatedBlock = await CrmMainService.getBlockById(f14, f11);

      const syncedBlock = await updateBookmark(updatedBlock.data[0]);

      setSelectedSearchFilter(syncedBlock);
      setPrevTicket(null);
      setNextTicket(null);
      setRow(null);
      setBookmarkLoading(false);
      setDrawerOpen(true);
    } catch (error) {
      sweetStatusAlert("Failed", "Failed to open bookmark", "error");
      setBookmarkLoading(false);
    }
  };

  const handleOpenNotificationModal = () => {
    setIsModalNotificationModel(true);
  };

  const handleCloseNotificationModal = () => {
    setIsModalNotificationModel(false);
  };

  const handleDeleteTicket = async (blockId) => {
    try {
      setDeleteLoading(true);

      // Step 1: Delete the ticket
      const deleteResponse = await CrmMainService.deleteBlockById(blockId);

      if (deleteResponse.data === -1) {
        setDeleteLoading(false);
        sweetStatusAlert("Warning!", deleteResponse.message.error, "info");
        return;
      }

      // Step 2: Find the prevTicket and nextTicket
      let prevTicket = null;
      let nextTicket = null;

      for (const row of searchFilters) {
        for (let i = 0; i < row.length; i++) {
          if (row[i].f14 === blockId) {
            prevTicket = i > 0 ? row[i - 1] : null;
            nextTicket = i < row.length - 1 ? row[i + 1] : null;
            break;
          }
        }
        if (prevTicket !== null || nextTicket !== null) break;
      }

      if (prevTicket && nextTicket) {
        // Case 1: Deleted ticket is in the middle
        const updatePrevTicketPayload = {
          block_id: prevTicket.f14,
          next_block_id: nextTicket.f14,
        };
        await CrmMainService.crm_update_block_order(updatePrevTicketPayload);

        const updateNextTicketPayload = {
          block_id: nextTicket.f14,
          parent_block_id: prevTicket.f14,
        };
        await CrmMainService.crm_update_block_order(updateNextTicketPayload);
      } else if (prevTicket && !nextTicket) {
        // Case 2: Deleted ticket is at the end
        const updatePrevTicketPayload = {
          block_id: prevTicket.f14,
          next_block_id: null,
        };
        await CrmMainService.crm_update_block_order(updatePrevTicketPayload);
      } else if (!prevTicket && nextTicket) {
        // Case 3: Deleted ticket is at the start
        const updateNextTicketPayload = {
          block_id: nextTicket.f14,
          parent_block_id: null,
        };
        await CrmMainService.crm_update_block_order(updateNextTicketPayload);
      }

      await handleSearchFilter();

      setDeleteLoading(false);
      sweetStatusAlert("Success!", "Ticket deleted successfully", "success");
    } catch (error) {
      setDeleteLoading(false);
      sweetStatusAlert(
        "Failed!",
        "An error occurred while deleting the ticket",
        "error"
      );
      console.error("Error deleting ticket:", error);
    }
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "800px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  const handleFilterForLinkedBlocksInRelay = async (blocks) => {
    setDrawerOpen(false);
    handleFilterForLinkedBlocks(blocks);
  };

  const expandedRowTickets =
    expandedRowIndex !== null ? searchFilters[expandedRowIndex] : [];

  const handleChartOpen = () => {
    setIsChartModalOpen(true);
  };

  const handleChartClose = () => {
    setIsChartModalOpen(false);
  };

  return (
    <div className="crm-relay-container">
      {/* Header Section */}
      <div className="header-section d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <p className="condition-text">
            <BookmarksIcon sx={{ color: "#fab732", marginRight: "8px" }} />
            Bookmarks -
          </p>
          <Breadcrumb handleOpenDrawerBookmark={handleOpenDrawerBookmark} />
        </div>
        <div style={{ display: "flex", gap: "16px" }}>
          <Tooltip title="CRM Analytics" arrow>
            <div
              className="notification-icon"
              style={{ cursor: "pointer" }}
              onClick={handleChartOpen}
            >
              <BarChartIcon />
            </div>
          </Tooltip>
          {/* Add this modal component at the bottom of your return statement */}

          <Tooltip title="Reminders" arrow>
            <div
              className="notification-icon"
              style={{ cursor: "pointer", position: "relative" }}
              onClick={handleOpenNotificationModal}
            >
              <NotificationsIcon />
              {notificationCount > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-5px",
                    right: "-5px",
                    backgroundColor: "red",
                    color: "white",
                    borderRadius: "50%",
                    width: "18px",
                    height: "18px",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {notificationCount}
                </span>
              )}
            </div>
          </Tooltip>
        </div>
      </div>
      <div className="selectedRule">
        <div className="d-flex align-items-center">
          <p>Sorting order - </p>
          {selectedSortOrder.map((index) => (
            <p key={index} className="sortingOrder">
              {index + 1}
            </p>
          ))}
        </div>

        {searchFilters?.length > 0 && (
          <FormControlLabel
            className="switchToggle"
            control={
              <Switch
                checked={matchSwitch === 1}
                onChange={(event) => {
                  const newValue = event.target.checked ? 1 : 0;
                  setMatchSwitch(newValue);
                  setSortOrder(Array(maxTickets).fill(null));
                  setFormattedSortOrder("");
                  setSelectedSortOrder([]);
                  handleSearchFilter("");
                }}
                color="primary"
              />
            }
            label="Show matched tickets only"
          />
        )}
      </div>
      <div className="test" style={{ overflowX: "auto" }}>
        {searchFilters?.length > 0 && (
          <div
            className="sort-toggles"
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <button
              className="clearSortBtn"
              onClick={handleClearAll}
              style={{ whiteSpace: "nowrap" }}
            >
              <DeleteForeverIcon />
              Clear
            </button>

            {Array.from({ length: maxTickets }).map((_, index) => (
              <Grid
                item
                xs={2}
                md={1}
                key={index}
                sx={{ minWidth: 175, maxWidth: 175 }}
              >
                <div className="sortIcon" style={{ overflow: "auto" }}>
                  <Tooltip
                    placement="top"
                    title={(() => {
                      switch (sortOrder[index]) {
                        case "A":
                          return "Ascending";
                        case "D":
                          return "Descending";
                        default:
                          return "Not Selected";
                      }
                    })()}
                    arrow
                  >
                    <div className="sorting">
                      <p className="sortNo">{index + 1}</p>
                      <button
                        className={`w-12 h-12 duration-300`}
                        style={{
                          backgroundColor: (() => {
                            switch (sortOrder[index]) {
                              case "A":
                                return "#f0d0f5";
                              case "D":
                                return "#cad1da";
                              default:
                                return "#ffffff";
                            }
                          })(),
                          border: (() => {
                            switch (sortOrder[index]) {
                              case "A":
                                return "2px solid #d0a0d5";
                              case "D":
                                return "2px solid #a0a7b0";
                              default:
                                return "2px solid #cccccc";
                            }
                          })(),
                          cursor: "pointer",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => {
                          const newOrder =
                            sortOrder[index] === "A"
                              ? "D"
                              : sortOrder[index] === "D"
                              ? null
                              : "A";
                          handleToggle(index, newOrder);
                        }}
                      >
                        {sortOrder[index] === "A" ? (
                          <SwapVertIcon />
                        ) : sortOrder[index] === "D" ? (
                          <div className="sort2">
                            <SwapVertIcon />
                          </div>
                        ) : (
                          <HeightIcon />
                        )}
                      </button>
                    </div>
                  </Tooltip>
                </div>
              </Grid>
            ))}
          </div>
        )}
        {searchLoading ? (
          <CRMRelaySkeleton />
        ) : (
          <>
            {searchFilters?.map((row, rowIndex) => {
              // Filter tickets based on matchSwitch and f40
              const filteredTickets =
                matchSwitch === 1
                  ? row.filter((ticket) => ticket.f40 === 1)
                  : row;

              return (
                <div key={rowIndex} className="relay-row-container">
                  <div className="relay-row d-flex align-items-center">
                    <p className="relayName">{row[0]?.f12}</p>
                    <div className="name-expand">
                      <div
                        className="expand-icon"
                        onClick={() => handleOpenModal(rowIndex)}
                      >
                        <ExpandIcon />
                      </div>
                      <p className="ticketCount relayName">
                        {filteredTickets.length} tickets
                      </p>
                    </div>

                    <div className="tickets-row">
                      <Tooltip title="Add a ticket here" placement="top" arrow>
                        <Card
                          className="add-ticket-card single"
                          onClick={() => handleOpenNewDrawer(null, row[0])}
                        >
                          <AddIcon />
                        </Card>
                      </Tooltip>

                      {filteredTickets.map((ticket, ticketIndex) => (
                        <React.Fragment key={ticketIndex}>
                          <TicketContainer
                            onClick={() => handleOpenDrawer(ticket, row)}
                            blockId={ticket?.f14}
                            blockTitle={ticket?.f16}
                            block_status={ticket?.f29}
                            block_match={ticket?.f40}
                            task_status={ticket?.f25}
                            onDelete={handleDeleteTicket}
                          />

                          <Tooltip
                            title="Add a ticket here"
                            placement="top"
                            arrow
                          >
                            <Card
                              className="add-ticket-card many"
                              onClick={() =>
                                handleOpenNewDrawer(
                                  ticket,
                                  filteredTickets[ticketIndex + 1]
                                )
                              }
                            >
                              <AddIcon />
                            </Card>
                          </Tooltip>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}

            <hr />
            {/* Add New Relay */}

            <div className="row Line">
              <div className="emspcls"></div>
              <Tooltip placement="top" title="Add a new relay here" arrow>
                <Card className="startRelay" onClick={handleOpenRelayDrawer}>
                  Add a new trail&nbsp;
                  <AddIcon />
                </Card>
              </Tooltip>
            </div>
            <hr />

            {deleteLoading && (
              <Box sx={overlayStyle}>
                <CircularProgress size={60} color="primary" />
              </Box>
            )}
            {bookmarkLoading && (
              <Box sx={overlayStyle}>
                <CircularProgress size={60} color="primary" />
              </Box>
            )}
          </>
        )}
      </div>

      <CrmDrawer
        open={drawerOpen}
        onClose={handleCloseDrawer}
        selectedSearchFilter={selectedSearchFilter}
        state={state?.state}
        handleSearchFilter={handleSearchFilter}
        prevTicket={prevTicket}
        nextTicket={nextTicket}
        onNavigate={handleNavigate}
        handleFilterForLinkedBlocks={handleFilterForLinkedBlocksInRelay}
        fetchAllReminders={fetchAllReminders}
      />

      <CrmNewDrawer
        open={newDrawerOpen}
        onClose={handleCloseNewDrawer}
        state={state?.state}
        prevTicket={selectedSearchFilter?.prevTicket}
        nextTicket={selectedSearchFilter?.nextTicket}
        handleSearchFilter={handleSearchFilter}
        fetchAllReminders={fetchAllReminders}
      />

      <CrmNewRelayDrawer
        open={relayDrawerOpen}
        onClose={handleCloseRelayDrawer}
        state={state?.state}
        handleSearchFilter={handleSearchFilter}
        fetchAllReminders={fetchAllReminders}
      />

      <Reminder
        open={isModalNotificationModel}
        onClose={handleCloseNotificationModal}
        reminders={reminders}
        state={state?.state}
        fetchAllReminders={fetchAllReminders}
        onCloseDrawer={handleCloseDrawer}
        handleSearchFilter={handleSearchFilter}
        handleNavigate={handleNavigate}
        handleFilterForLinkedBlocks={handleFilterForLinkedBlocksInRelay}
      />
      <CrmStatModel
        open={isChartModalOpen}
        onClose={handleChartClose}
        state={state?.state}
      />

      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box sx={modalStyle}>
          <Carousel items={expandedRowTickets} deviceType="desktop" />
        </Box>
      </Modal>
    </div>
  );
};

export default CRMRelay;
